<template>
  <div
    class="btn_wrapper"
    @click="onClick($event)"
  >
    <div
      class="btn--icon"
      :class="{
        'ml-auto': isVertical,
        'mr-auto': isVertical,
        'mr-2': !isVertical
      }"
    >
      <div class="icon_wrapper">
        <slot />
      </div>
    </div>
    <div
      class="btn--text"
      :class="{
        'text-center': isVertical,
        'd-block': isVertical,
        [`text-${color}`]: !!color
      }"
    >
      {{ title }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'CircleIconButton',
  props: {
    title: {
      type: String,
      default: ''
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>
